import LabeledSelect from "./LabeledSelect";
import {debounce, isEmpty} from "lodash";
import {useCallback} from "react";
import {requestCampaignSearch} from "../../redux/sagas/requests/searchService";

const CampaignSearchSelect = ({
                             label, value, onChange, placeholder = "Search Campaigns",
                             emptyMsg = "No data", ...props
                           }) => {

  // noinspection JSCheckFunctionSignatures
  const debouncedSearchCampaign = useCallback(
    debounce((inputText, callback) => {
      handleSearchCampaign(inputText).then((options) => callback(options));
    }, 500),
    [handleSearchCampaign]
  );


  return (
    <LabeledSelect label={label} value={value} getOptionLabel={(option) => option.name}
                   getOptionValue={(option) => option.id} placeholder={placeholder}
                   onChange={onChange} emptyMsg={emptyMsg} {...props} loadOptions={debouncedSearchCampaign}/>
  );


};

export default CampaignSearchSelect;

const handleSearchCampaign = (input) => {
  if (isEmpty(input)) {
    return [];
  }

  return requestCampaignSearch(input).then((response) =>
    response.data ? response.data : []
  );

};
